import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Map old URLs to new URLs
const redirectMap = {
  '/pc-computer-repair': '/pc-laptop-repair',
  '/services-2': '/device-repair',
  '/services-3': '/monitoring',
  '/blank-1': '/monitoring',
  '/book-online': '/contact',
  '/isf-assistant': '/contact',
  '/portal-home': '/monitoring',
  '/booking-calendar/meeting-with-tech-expert': '/contact'
};

function Redirects() {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const currentPath = location.pathname;
    
    // Check if the current path is in our redirect map
    if (redirectMap[currentPath]) {
      navigate(redirectMap[currentPath], { replace: true });
    }
  }, [location, navigate]);
  
  // This component doesn't render anything
  return null;
}

export default Redirects; 